import React from 'react';
import Logo from './Logo';

const Footer = () => {
  const productLinks = [
    'Sapi Qurban',
    'Domba & Kambing',
    'Custom Order',
    'Organic Farming',
    'Pakan Ternak',
    'Konsultasi'
  ];

  const companyLinks = [
    'Tentang Kami',
    'Visi & Misi',
    'Tim Kami',
    'Karir',
    'Blog',
    'Press Release'
  ];

  const supportLinks = [
    'Pusat Bantuan',
    'FAQ',
    'Syarat & Ketentuan',
    'Kebijakan Privasi',
    'Hubungi Kami',
    'Panduan Pemesanan'
  ];

  const socialIcons = [
    'fa-instagram',
    'fa-facebook',
    'fa-youtube',
    'fa-whatsapp'
  ];

  return (
    <footer id="footer" className="bg-primary text-white py-12 sm:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-10 sm:mb-12">
          <div className="space-y-5 sm:space-y-6">
            <Logo size="medium" showText={false} />
            <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
              Mensejahterakan petani, peternak, dan mitra melalui 
              produk berkualitas tinggi dan layanan terpercaya.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              {socialIcons.map((icon, index) => (
                <span key={index} className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-accent hover:text-primary transition-colors cursor-pointer">
                  <i className={`fa-brands ${icon} text-sm sm:text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Produk & Layanan</h4>
            <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base">
              {productLinks.map((link, index) => (
                <li key={index}>
                  <span className="text-gray-300 hover:text-accent transition-colors cursor-pointer">{link}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Perusahaan</h4>
            <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base">
              {companyLinks.map((link, index) => (
                <li key={index}>
                  <span className="text-gray-300 hover:text-accent transition-colors cursor-pointer">{link}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Dukungan</h4>
            <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base">
              {supportLinks.map((link, index) => (
                <li key={index}>
                  <span className="text-gray-300 hover:text-accent transition-colors cursor-pointer">{link}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm mb-4 md:mb-0">
              © 2024 PAK MoO. Semua hak cipta dilindungi undang-undang.
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-300">
              <span>Dibuat dengan ❤️ di Indonesia</span>
              <span>•</span>
              <span>Halal MUI Certified</span>
              <span>•</span>
              <span>Organic Certified</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

